module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "6em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "float": "left",
      "font-size": "13px",
      "color": "#5703a5"
    }
  }, [_vm._v("Service Charge: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "margin-top": "-0.41em"
    }
  }, [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.service_charge_balance)))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#242323"
    }
  }, [_vm._v("Add funds to your Service Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processing_fee.amount),
      expression: "processing_fee.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Amount"
    },
    domProps: {
      "value": (_vm.processing_fee.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.processing_fee.amount = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.menu_tab_inner_view['addProcessingFees']) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    staticStyle: {
      "margin-top": "5px",
      "background-color": "#5703a5",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddProcessingFees()
      }
    }
  }, [_vm._v("Enter")])]) : _vm._e()]), _vm._v(" "), (_vm.menu_tab_inner_view['addProcessingFees']) ? _c('div', [(((_vm.data_error.email))) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("Provide your email address to make an online payment")]), _vm._v(_vm._s(_vm.user) + "\r\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Email Address"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    staticStyle: {
      "margin-top": "5px",
      "background-color": "#5703a5",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editProfileDetails()
      }
    }
  }, [_vm._v("Save")])])]) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    staticStyle: {
      "margin-top": "5px",
      "background-color": "#5703a5",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.addtoProcessingFee()
      }
    }
  }, [_vm._v("Add Fund")])])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Service charge Transactions "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("(" + _vm._s(Object.keys(_vm.processing_fee_transactions).length) + ")")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, _vm._l((_vm.processing_fee_transactions), function(txn, tdex) {
    return _c('div', {
      staticClass: "col-xs-12 mp0"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8",
      staticStyle: {
        "padding-left": "1.3em"
      }
    }, [_c('p', [(txn.data_transaction_action_type == 1) ? _c('span', [_vm._v("Account Credited")]) : _vm._e(), _vm._v(" "), (txn.data_transaction_action_type == 2) ? _c('span', [_vm._v("Account Debited")]) : _vm._e(), _c('br'), _vm._v("\r\n                  " + _vm._s(txn.data_transaction_time_ago) + "\r\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('p', {
      staticClass: "sp-app-default-color"
    }, [_c('span', {
      staticClass: "nra-fmt"
    }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(txn.data_transaction_amount)))])])])
  }))])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "margin-top": "-0.1em"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "font-size": "18px",
      "border-radius": "8px",
      "line-height": "0.8",
      "color": "#000000"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down",
    staticStyle: {
      "color": "#5703a5"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-exchange",
    staticStyle: {
      "padding": "0.4em 0.4em",
      "border-radius": "50%",
      "background-color": "#eee",
      "color": "#242323"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1af827b9"}!./src/pages/AgentServices/ServiceCharges/template.html
// module id = 553
// module chunks = 0